/* Custom-element lifecycle also handles Shopify section replacement. */
(() => {
  if (customElements.get('co2-resource-library')) return;
  customElements.define('co2-resource-library', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const controls = this.querySelector('.crl-filter');
      const buttons = [...this.querySelectorAll('[data-filter]')];
      const cards = [...this.querySelectorAll('[data-audience]')];
      const status = this.querySelector('.crl-status');
      if (!controls || !status || !cards.length) return;
      controls.hidden = false;
      buttons.forEach(button => button.addEventListener('click', () => {
        const filter = button.dataset.filter;
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        let count = 0;
        cards.forEach(card => {
          card.hidden = filter !== 'all' && !card.dataset.audience.split(' ').includes(filter);
          if (!card.hidden) count++;
        });
        this.dataset.filtered = String(filter !== 'all');
        status.textContent = filter === 'all' ? `All ${count} subjects` : `${count} subjects · ${button.textContent.trim()}`;
      }));
    }
  });
})();
